define('responsive-gameday/controllers/TeamMatchupSummaryViewController',['require','exports','module','Responsive/controllers/ViewController','Responsive/util/renderComplete','./LinescoreViewController','../views/Monitor/Events/ViewModelUpdateEvents','message-service/message-service','../views/render/TeamMatchupSummaryViewRender','Wax/Wax','jquery','FitText.js/jquery.fittext'],function(require,exports,module){
    // Add private variables here
    var ViewController = require("Responsive/controllers/ViewController"),
        renderComplete = require("Responsive/util/renderComplete"),
        LinescoreViewController = require( './LinescoreViewController' ),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        TeamMatchupSummaryViewRender = require( "../views/render/TeamMatchupSummaryViewRender" ),
        Wax = require( "Wax/Wax" ),
        $ = require('jquery'),
        fitText = require('FitText.js/jquery.fittext');

    var renderers = null,
        Superclass;
    
    // Constructor
    function TeamMatchupSummaryViewController(opts) {
        opts = opts || {};
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "TeamMatchupSummary";
        this.viewRender = new TeamMatchupSummaryViewRender();
        this.viewRender.viewState.showHR = opts.showHR===true;
        this.viewRender.viewState.miniMatchup = opts.miniMatchup===true;
        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    ViewController.spawn(TeamMatchupSummaryViewController).define({
        loadView : function(){
            Superclass.loadView.call(this);
            this.setClassName("TeamMatchupSummaryViewController");
        },

        viewWillAppear : function(){
        	var that=this;
			this.onBeat = this.onBeat || function(data){
                LinescoreViewController.embeddedHelper(that, data.linescore);
				that.view.innerHTML = that.viewRender.render(data);
				renderComplete(function(){
                    jQuery('.header',that.view).fitText(2.0,{
                        maxFontSize : 28
                    });
                });
                LinescoreViewController.setEmbeddableScrollBar(that, data.linescore)
                LinescoreViewController.embeddeScrollerdHelper(that, data.linescore);
			}

            Superclass.viewWillAppear.call(this);
		},
		viewDidAppear : function(){
            var that = this;
            Superclass.viewDidAppear.call(this);
            MessageService.addListener.call(that, VMEvents.UPDATE_TEAM_MATCHUP_SUMMARY, this.onBeat);
            MessageService.publish(VMEvents.REQUEST_TEAM_MATCHUP_SUMMARY);
        },
        viewWillDisappear : function(){
            Superclass.viewWillDisappear.call(this);
            MessageService.removeListener.call(this, VMEvents.UPDATE_TEAM_MATCHUP_SUMMARY, this.onBeat);
        }
    });

    Superclass = TeamMatchupSummaryViewController.superclass;
    return TeamMatchupSummaryViewController;
});
